import { render } from "./verify-email.vue?vue&type=template&id=2f8c81f8"
import script from "./verify-email.vue?vue&type=script&lang=js"
export * from "./verify-email.vue?vue&type=script&lang=js"

import "./verify-email.vue?vue&type=style&index=0&id=2f8c81f8&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\personal\\ims-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__